import styled from 'styled-components';
import discountBg from '../../assets/images/discount_bg.svg';
import bg from '../../assets/images/modal_offer_bg.jpg';
import mask from '../../assets/images/offer_mask.svg';
import { TextLabel } from '../TextLabel';

const StyledModalWrapper = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	z-index: 5;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
	height: 100%;
	background-color: rgba(17, 19, 20, 0.85);
	opacity: 0;
	transition: opacity 0.3s ease;

	&.modal-enter {
		opacity: 0;
	}

	&.modal-enter-active,
	&.modal-enter-done,
	&.modal-exit {
		opacity: 1;
	}

	&.modal-exit-active {
		opacity: 0;
	}
`;

const StyledContainer = styled.div`
	display: flex;
	flex-direction: column;
	width: 600px;
	background-color: #111314;
	box-shadow: 0px 6px 80px rgba(0, 0, 0, 0.75);
	border-radius: 10px;
`;

const StyledTopContainer = styled.div`
	display: flex;
	justify-content: space-between;
	padding: 30px;

	${TextLabel} {
		font-weight: 500;
		font-size: 18px;
		color: #ffffff;
	}
`;

const StyledCloseButton = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	width: 20px;
	height: 20px;
	background-color: rgba(255, 255, 255, 0.1);
	border-radius: 6px;
	transition: background-color 0.3s ease;
	cursor: pointer;

	img {
		width: 10px;
		height: 10px;
		transition: filter 0.3s ease;
		user-select: none;
	}

	&:hover {
		background-color: #ffffff;

		img {
			filter: invert(100%);
		}
	}
`;

const StyledContentContainer = styled.div`
	&.container-enter {
		opacity: 0;
	}

	&.container-enter-active,
	&.container-enter-done,
	&.container-exit {
		opacity: 1;
	}

	&.container-exit-active {
		opacity: 0;
	}
`;

const StyledBackgroundWrapper = styled.div`
	position: relative;
	width: 100%;
	height: 459px;
`;

const StyledBackground = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	z-index: 1;
	width: 600px;
	height: 459px;
	background-image: url(${bg});
	background-repeat: no-repeat;
	background-size: cover;
	background-position: center;

	mask-image: url(${mask});
	mask-size: 600px 600px;
	mask-repeat: no-repeat;
	mask-position: center center;
`;

const StyledDiscountBannerContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 10px;
	width: 100%;
	height: 50px;
	background-image: url(${discountBg});
	background-repeat: no-repeat;
	background-position: center;
	background-size: cover;
	background-color: #b51313;
	box-shadow: 0 14px 20px rgba(0, 0, 0, 0.5);

	${TextLabel} {
		font-weight: 400;
		font-size: 16px;
		color: #ffffff;
	}

	img {
		width: 20px;
		height: 20px;
		user-select: none;
		pointer-events: none;
	}
`;

const StyledOfferNameContainer = styled.div`
	position: absolute;
	bottom: 27px;
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 10px;
	width: 100%;

	${TextLabel} {
		color: #ffffff;
	}
`;

const StyledViewButton = styled.button`
	display: block;
	width: 190px;
	height: 50px;
	background-color: #2d70da;
	border: none;
	border-radius: 10px;
	margin: 30px auto 0;
	font-family: 'GT Walsheim Pro';
	font-style: normal;
	font-weight: 400;
	font-size: 18px;
	line-height: 21px;
	color: #ffffff;
	transition:
		background-color 0.3s ease,
		color 0.3s ease;
	cursor: pointer;
	user-select: none;

	&:hover {
		background-color: #ffffff;
		color: #000000;
	}
`;

const StyledControlsContainer = styled.div`
	display: grid;
	grid-template-columns: 100px 1fr 100px;
	padding: 30px;
`;

const StyledControlsButton = styled.button`
	width: 100px;
	height: 50px;
	background-color: rgba(255, 255, 255, 0.1);
	border: none;
	border-radius: 10px;
	font-family: 'GT Walsheim Pro';
	font-style: normal;
	font-weight: 400;
	font-size: 18px;
	line-height: 21px;
	color: #ffffff;
	transition:
		background-color 0.3s ease,
		color 0.3s ease;
	cursor: pointer;
	user-select: none;

	&:hover {
		background-color: #ffffff;
		color: #000000;
	}
`;

const StyledDotsContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 20px;
`;

const StyledDot = styled.div<{ $selected?: boolean }>`
	width: 10px;
	height: 10px;
	border-radius: 10px;
	cursor: pointer;
	background-color: ${(props) =>
		props.$selected ? '#2D70DA' : 'rgba(255, 255, 255, 0.1)'};

	&:hover {
		background-color: #ffffff;
	}
`;

export {
	StyledModalWrapper,
	StyledContainer,
	StyledTopContainer,
	StyledCloseButton,
	StyledBackgroundWrapper,
	StyledDiscountBannerContainer,
	StyledOfferNameContainer,
	StyledViewButton,
	StyledControlsContainer,
	StyledControlsButton,
	StyledDotsContainer,
	StyledDot,
	StyledBackground,
	StyledContentContainer,
};
